import * as http from '@/model/http'
import type { UserReadme, UserReadmeNullable } from './schema'

const fetchReadme = async (): Promise<UserReadmeNullable> => {
  const { data } = await http.get('/user-readme')
  return data.readme
}

const upsertReadme = async (
  content: string,
  title?: string
): Promise<UserReadme> => {
  const { data } = await http.post('/user-readme', { content, title })
  return data.readme
}

const fetchReadmes = async (): Promise<UserReadme[]> => {
  const { data } = await http.get('/user-readmes')
  return data.readmes
}

const createReadme = async (
  title: string,
  content: string,
  isMain = false
): Promise<UserReadme> => {
  const { data } = await http.post('/user-readmes', {
    title,
    content,
    is_main: isMain
  })
  return data.readme
}

const updateReadme = async (
  id: number,
  payload: { title?: string; content?: string; is_main?: boolean }
): Promise<UserReadme> => {
  const { data } = await http.put(`/user-readmes/${id}`, payload)
  return data.readme
}

const deleteReadme = async (id: number): Promise<void> => {
  await http['delete'](`/user-readmes/${id}`)
}

export type OrganizationContext = {
  id: number
  title: string
  content: string
  is_main?: boolean
}

// 組織コンテクスト（閲覧のみ・編集不可・最大1件）
const fetchOrganizationContexts = async (): Promise<OrganizationContext[]> => {
  const { data } = await http.get('/organization-contexts')
  return data.organization_contexts
}

// メインコンテクスト切替（個人/組織横断・全部で1個）
const setMainContext = async (
  kind: 'user' | 'org',
  id: number
): Promise<void> => {
  await http.post('/main-context', { kind, id })
}

export default {
  fetchReadme,
  upsertReadme,
  fetchReadmes,
  createReadme,
  updateReadme,
  deleteReadme,
  fetchOrganizationContexts,
  setMainContext
}
